<template>
  <div>
    <!-- Above List -->
    <div class="relative flex justify-center items-center pt-5">
      <p
        class="leading-none text-interaction-dark font-bold absolute"
        style="left:50%;top:0;transform:translateX(-50%)"
      >
        …<span class="text-chplus-tooltip">%</span>
      </p>
      <div class="smart-spider-box relative">
        <icon-laurel
          v-if="showLaurel"
          class="laurel absolute text-interaction-dark"
          style="transform:translateX(-50%);left:50%;top:-1rem"
        />
        <smart-spider
          :show-background="false"
          :show-light-background="true"
          :showUser="false"
        />
      </div>

      <list-tools
        v-if="showListTools"
        class="absolute right-0 text-interaction-dark"
        style="bottom: 0.8rem"
        :allowed-actions="['edit']"
        :always-expanded="true"
      />
    </div>
  </div>
</template>

<script>
import SmartSpider from "@/components/chart/SmartSpider";
import IconLaurel from "@/components/icons/IconLaurel";

import { ListMatch } from "@/utils/ListMatch";
import ListTools from "@/components/list/ListTools";

export default {
  name: "ListPlaceholder",
  components: {
    ListTools,
    SmartSpider,
    IconLaurel
  },
  mixins: [ListMatch],
  props: {
    showLaurel: {
      type: Boolean,
      default: false
    },
    showListTools: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.smart-spider-box {
  width: 4.09375rem;
  height: 4.09375rem;
}
.laurel {
  width: 7.09375rem;
  height: 7.09375rem;
}
@media screen and (min-width: 768px) {
  .smart-spider-box {
    width: 4.84375rem;
    height: 4.84375rem;
  }
  .laurel {
    width: 7.84375rem;
    height: 7.84375rem;
  }
}
</style>
